module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/babel-runtime/regenerator/index.js
// module id = 48
// module chunks = 2